<template>
  <div class="index-bd">
    <!-- banner开始 -->
    <!--  :options="swiperOption"   v-if="swiperSlides.length > 0"-->
    <swiper
      class="fullSlide"
      :options="swiperOption"
      v-if="swiperSlides.length > 0"
    >
      <swiper-slide v-for="(slide, index) in swiperSlides" :key="index"
        ><img
          :src="imgBaseUrl + '/' + slide"
          :alt="slide.name"
          :title="slide.name"
      /></swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>

    <!-- 正文开始 -->
    <div class="four content">
      <h2 class="four_t" title="产品质量有保障 7天快速交货 专家现场技术指导">
        <em
          ><img
            src="@img/four_ico01.jpg"
            alt="产品质量有保障 7天快速交货 专家现场技术指导"
            title="产品质量有保障 7天快速交货 专家现场技术指导"
        /></em>
        万杰承诺：产品质量有保障 7天快速交货 专家现场技术指导
        <span
          >Wanjie promises: guaranteed product quality, 7-day fast delivery,
          expert on-site technical guidance</span
        >
      </h2>
      <ul class="ibrand-num">
        <li class="four_li01">
          <div class="spinner"></div>
          <countTo
            :startVal="startVal"
            :endVal="endVal1"
            :autoplay="autoplay"
          ></countTo>
          年
          <b>潜心研发</b>
        </li>
        <li class="four_li02">
          <div class="spinner"></div>
          <countTo
            :startVal="startVal"
            :endVal="endVal2"
            :autoplay="autoplay"
          ></countTo>
          项
          <b>累计专利</b>
        </li>
        <li class="four_li03">
          <div class="spinner"></div>
          <countTo
            :startVal="startVal"
            :endVal="endVal3"
            :autoplay="autoplay"
          ></countTo>
          天
          <b>快速交货</b>
        </li>
        <li class="four_li04">
          <div class="spinner"></div>
          <countTo
            :startVal="startVal"
            :endVal="endVal4"
            :autoplay="autoplay"
          ></countTo>
          亩
          <b>生产基地</b>
        </li>
        <div class="clear"></div>
      </ul>
    </div>

    <!-- case -->
    <!-- <div class="case_bg">
      <div class="content pr">
        <div class="case_t">
          <router-link to="/articleDetail">
            <b>{{ indexCaseList[curIndex].mainT }}</b>
            {{ indexCaseList[curIndex].subT }}
          </router-link>
        </div>
        <div class="case_l">
          <div class="case_intro">
            <div class="intro" v-for="(item, index) in indexCaseList[curIndex].advantage" :key="index">
              <p class="main">{{ item.title }}</p>
              <p class="sub" v-html="item.info"></p>
            </div>
          </div>
          <div class="case_img">
            <a href="/"><img :alt="indexCaseList[curIndex].title" :src="imgBaseUrl + '/guanwang/img-' + curIndex + '.jpg'" :title="indexCaseList[curIndex].title" /></a>
          </div>
        </div>
        <div class="case_r">
          <ul>
            <li :class="curIndex == index ? 'on' : ''" v-for="(item, index) in indexCaseList" :key="index" @mouseover="curIndex = index">
              <a href="/" :title="item.typeCh">
                <b>
                  {{ item.typeCh }}
                  <i>{{ item.typeEn }}</i>
                </b>
                <em>No.0{{ index + 1 }}</em>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="clear"></div>
    </div> -->

    <!--产品中心-->
    <div class="cp_bg">
      <div class="chanpin content">
        <h2 class="cp_t">
          <a href="/products/all" target="_blank" title="产品展示">产品展示</a>
        </h2>
        <div class="cp_l fl pr">
          <h3><a title="产品分类">产品分类</a></h3>
          <ul class="cp_ul01">
            <li v-for="(product, index) in products" :key="index">
              <router-link
                :to="product.name | toProDetail('/products/')"
                :title="product.name"
                >{{ product.name }}</router-link
              >
            </li>
          </ul>
        </div>
        <div class="cp_r fr">
          <ul>
            <li
              v-for="(product, index) in products"
              :key="index"
              v-if="index < 9"
            >
              <router-link
                :to="product.name | toProDetail('/products/')"
                target="_blank"
                :title="product.name"
              >
                <img
                  :alt="product.name"
                  :src="
                    product.product_class_img +
                      '?x-oss-process=image/resize,h_296,w_296'
                  "
                  :title="product.name"
                />
                <span>{{ product.name }}</span>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="clear"></div>
      </div>
    </div>

    <!--广告条-->
    <div
      class="ban01"
      title="机械打造手工味 以食业 做实业 惠民生 为亿万家庭主食服务"
      alt="机械打造手工味 以食业 做实业 惠民生 为亿万家庭主食服务"
    >
      <a href=""></a>
      <!-- <div class="content pr">
        <p>
          <span>
            机械打造手工味
            <b>以食业 做实业 惠民生 为亿万家庭主食服务</b>
          </span>
          <em><a href="" target="_blank">立即咨询</a></em>
        </p>
        <img src="../assets/img/ban01-img.png" alt="" />
      </div> -->
    </div>

    <!--优势-->
    <div class="ys_tbg">
      <div class="content">
        <h2
          class="four_t"
          title="25年专注食品机械研发 高性价比 7天快速发货 专家现场技术指导"
        >
          <em>
            <img
              src="@img/ys_ico01.jpg"
              alt="25年专注食品机械研发 高性价比 7天快速发货 专家现场技术指导"
              title="25年专注食品机械研发 高性价比 7天快速发货 专家现场技术指导"
            />
          </em>
          {{ endVal1 }}年专注食品机械研发 高性价比 7天快速发货 专家现场技术指导
          <span>实现食品标准生产与物联智能服务 保障老百姓主食健康</span>
        </h2>
      </div>
      <div class="ys content">
        <dl>
          <dt>01</dt>
          <dd>
            <h5 title="选万杰智能，品质有保障">
              选万杰智能，品质有保障
              <em>INDUSTRY BRANDS</em>
            </h5>
            <p>近30年沉淀，行业标准，值得信赖；</p>
            <!-- <p>24年专注食品机械研发生产</p>
            <p>中国文化主食机械的标准制定者</p>
            <p>中式面点产业化系统的带领者</p> -->
            <!-- <span><a rel="nofollow" href="" target="_blank">立即咨询</a></span> -->
          </dd>
        </dl>
        <div class="ys-img">
          <img src="../assets/img/ys-01.jpg" alt="品牌优势 行业知名品牌" />
        </div>
      </div>
      <div class="ys content">
        <div class="ys-img">
          <img src="../assets/img/ys-02.jpg" alt="选万杰智能，技术有保障" />
        </div>
        <dl>
          <dt>02</dt>
          <dd>
            <h5 title="选万杰智能，技术有保障">
              选万杰智能，技术有保障
              <em>COST-EFFECTIVE</em>
            </h5>
            <p>每年投入研发百万元，145项专利筑造技术壁垒。</p>
            <p>现有多款智能设备已成为行业翘楚，更多智能机械即将面世；</p>
            <!-- <p>获得ISO9001：2000质量管理体系认证 产品性价比优</p>
            <p>于2013年被认定为国家级高新技术企业</p>
            <p>产品广泛应用于各种大型食品企业，享有很高的声誉</p> -->
            <!-- <span><a rel="nofollow" href="" target="_blank">立即咨询</a></span> -->
          </dd>
        </dl>
      </div>
      <div class="ys content">
        <dl class="ys03-dl">
          <dt>03</dt>
          <dd>
            <h5 title="选万杰智能，售后有保障">
              选万杰智能，售后有保障
              <em class="m">MANUFACTURING STRENGTH</em>
            </h5>
            <p>全国六百个经销商服务网点</p>
            <p>数百名“阳光感恩服务”人员为您保驾护航</p>
            <!-- <p>2012年“万杰牌”被评为河南省著名商标</p>
            <p>食品机械加工全国十大知名品牌</p>
            <p>技能人才占百分之七十以上，各类机械加工设备110余台</p>
            <p>获得各项专利145项</p> -->
            <!-- <span><a rel="nofollow" href="" target="_blank">立即咨询</a></span> -->
          </dd>
        </dl>
        <div class="ys-img">
          <img
            src="../assets/img/ys-03.jpg"
            alt="生产实力16000多台/套年生产力"
          />
        </div>
      </div>
      <div class="ys content">
        <div class="ys-img">
          <img src="../assets/img/ys-04.png" alt="选万杰智能，技术有保障" />
        </div>
        <dl style="width:49.5%">
          <dt>04</dt>
          <dd>
            <h5 title="选万杰智能，服务有保障">
              选万杰智能，服务有保障
              <em>SERVICE GUARANTEE</em>
            </h5>
            <p>
              销售人员多为餐饮相关行业从业者，更懂行
            </p>
            <p>强大的设计团队配合，给您的方案更贴合市场；</p>
            <!-- <p>获得ISO9001：2000质量管理体系认证 产品性价比优</p>
            <p>于2013年被认定为国家级高新技术企业</p>
            <p>产品广泛应用于各种大型食品企业，享有很高的声誉</p> -->
            <!-- <span><a rel="nofollow" href="" target="_blank">立即咨询</a></span> -->
          </dd>
        </dl>
      </div>
      <div class="ys content">
        <dl>
          <dt>05</dt>
          <dd>
            <h5 title="选择万杰 飞燕联保平台">
              选择万杰，飞燕联保平台
              <em>CHOOSE WANJIE PLATFORM</em>
            </h5>
            <p>飞燕联保：是万杰依托互联网打造的共享联保服务平台 </p>
            <p>售后专业人员，全国覆盖，快速响应</p>
          </dd>
        </dl>
        <div class="ys-img">
          <img src="../assets/img/ys-05.jpg" alt="品牌优势 行业知名品牌" />
        </div>
      </div>
    </div>

    <!-- 案例展示 -->
    <div class="anli_bg">
      <div class="anli content">
        <h2 class="anli_t">
          <a href="/case/" target="_blank" title="经典案例展示">经典案例展示</a>
        </h2>
        <div class="anli_l fl">
          <ul>
            <li
              :class="{ cur: activeAnli == 22 }"
              @mouseover="getNewAnliList(22)"
            >
              <router-link to="/case/brand" title="品牌企业案例">
                品牌企业案例
                <em>Brand enterprise</em>
              </router-link>
            </li>
            <li
              :class="{ cur: activeAnli == 23 }"
              @mouseover="getNewAnliList(23)"
            >
              <router-link to="/case/public" title="公共食堂案例">
                公共食堂案例
                <em>Public canteen</em>
              </router-link>
            </li>
            <li
              :class="{ cur: activeAnli == 24 }"
              @mouseover="getNewAnliList(24)"
            >
              <router-link to="/case/monopoly" title="专卖连锁案例">
                专卖连锁案例
                <em>Monopoly chain</em>
              </router-link>
            </li>
            <li
              :class="{ cur: activeAnli == 25 }"
              @mouseover="getNewAnliList(25)"
            >
              <router-link to="/case/individual" title="个体工商户案例">
                个体工商户案例
                <em>Individual business</em>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="anli_list fr">
          <ul>
            <li v-for="(item, index) in anliList" :key="index">
              <a
                :href="
                  activeAnli == 22
                    ? '/case/brand'
                    : activeAnli == 23
                    ? '/case/public'
                    : activeAnli == 24
                    ? '/case/monopoly'
                    : '/case/individual'
                "
                target="_blank"
              >
                <img
                  :alt="item.title"
                  :src="item.article_img"
                  :title="item.title"
                />
                <p>{{ item.title }}</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <!-- <div class="anli_bg">
      <div class="anli content">
        <h2 class="anli_t"><a href="/case/" target="_blank" title="经典案例展示">经典案例展示</a></h2>
        <div class="anli_l fl">
          <ul>
            <li class="cur">
              <router-link to="/case/brand" title="品牌企业案例">
                品牌企业案例
                <em>Brand enterprise</em>
              </router-link>
            </li>
            <li class="">
              <router-link to="/case/public" title="公共食堂案例">
                公共食堂案例
                <em>Public canteen</em>
              </router-link>
            </li>
            <li class="">
              <router-link to="/case/monopoly" title="专卖连锁案例">
                专卖连锁案例
                <em>Monopoly chain</em>
              </router-link>
            </li>
            <li class="">
              <router-link to="/case/individual" title="个体工商户案例">
                个体工商户案例
                <em>Individual business</em>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="anli_c fl">
          <swiper class="anli_cm" :options="anliSwiperOption" v-if="anliList.length > 0">
            <swiper-slide v-for="(slide, index) in anliList" :key="index"><img :src="slide.article_img" :title="slide.title" :alt="slide.title" /></swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <div class="anli_r fr">
          <b><a href="/case/" title="最新案例">最新案例</a></b>
          <ul>
            <li v-for="(item, index) in newAnli" :key="index">
              <a href="/" target="_blank">
                <img :alt="item.title" :src="item.article_img" :title="item.title" />
                <span>{{ item.title }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="clear"></div>
    </div> -->

    <!-- 新闻中心 -->
    <div class="news_center content">
      <h2 class="news_bt">
        <a href="/news/all" target="_blank" title="新闻资讯">
          <em><img src="@img/xw_icon01.jpg"/></em>
          新闻资讯
        </a>
      </h2>
      <div class="news fl">
        <div class="news_t">
          <span><a href="/news/xwdt/">MORE</a></span>
          <em></em>
          <a href="/news/xwdt/" title="新闻动态">新闻动态</a>
        </div>
        <dl>
          <dt>
            <router-link
              :to="firstNew.classifyid | toNewDetail(newsTypes, firstNew.id)"
              target="_blank"
            >
              <img
                :alt="firstNew.title"
                :src="firstNew.article_img"
                :title="firstNew.title"
              />
            </router-link>
          </dt>
          <dd>
            <h3>
              <router-link
                :to="firstNew.classifyid | toNewDetail(newsTypes, firstNew.id)"
                :title="firstNew.title"
                >{{ firstNew.title }}</router-link
              >
            </h3>
            <div class="news_desc">
              <p>{{ firstNew.introduce }}</p>
            </div>
            <span
              ><router-link
                :to="firstNew.classifyid | toNewDetail(newsTypes, firstNew.id)"
                target="_blank"
                >查看详情</router-link
              ></span
            >
          </dd>
        </dl>

        <ul>
          <li v-for="(item, index) in newList" :key="index" v-if="index < 8">
            <em>0{{ index + 1 }}</em>
            <router-link
              :to="item.classifyid | toNewDetail(newsTypes, item.id)"
              target="_blank"
              :title="item.title"
              >{{ item.title }}</router-link
            >
          </li>
        </ul>
      </div>

      <!--常见问题解答-->
      <div class="wd fr">
        <div class="news_t">
          <span><a href="/about/problem">MORE</a></span>
          <em></em>
          <a href="/about/problem" title="常见问题">常见问题</a>
        </div>
        <!-- <scroll class="tempWrap" :data="problemList">
          <ul>
            <li class="slide" v-for="(item, index) in problemList" :key="index">
              <router-link to="" target="_blank" :title="item.problem">
                {{ item.problem }}
              </router-link>
              <p>{{ item.solve }}</p>
            </li>
          </ul>
        </scroll> -->

        <swiper
          class="tempWrap"
          :options="tempWrapOption"
          ref="tempWrapOption"
          v-if="problemList.length > 0"
        >
          <swiper-slide v-for="(item, index) in problemList" :key="index">
            <router-link to="/" target="_blank" :title="item.problem">{{
              item.problem
            }}</router-link>
            <p v-html="item.solve"></p>
          </swiper-slide>
        </swiper>
      </div>
      <div class="clear"></div>
    </div>

    <!-- 关于我们 -->
    <div class="ab_bg">
      <div class="about content">
        <h2 class="four_t">
          <router-link to="/about" target="_blank" title="关于我们">
            <em><img src="@img/wm_icon01.jpg"/></em>
            关于我们
          </router-link>
        </h2>
        <dl>
          <dt>
            <router-link to="/about" target="_blank"
              ><img alt="企业简介" src="@img/about.jpg" title="企业简介"
            /></router-link>
          </dt>
          <dd>
            <div class="ab_desc">
              万杰智能科技股份有限公司于1996年3月，注册资本8382万。公司位于襄城县循环经济产业集聚区中西部，主要产品包括智能鲜面条机、智能熟面机、智能包子成型机和智能主食生产线等。企业占地面积130余亩，员工400余人，其中科研人员占百分之十，专业技术人才占百分之八十以上，是国内比较大的面制主食机械生产企业之一。公司是全国面制主食机械行业的xianfeng、河南省质量标杆企业、河南省创新型试点企业...
            </div>
            <!-- <span><a href="/about/qiyejianjie/" target="_blank">查看更多</a></span> -->
          </dd>
        </dl>
        <div class="ab_bot">
          <router-link to="/about" title="企业简介" class="ab_btn01"
            >企业简介</router-link
          >
          <router-link to="/about/honor" title="资质荣誉" class="ab_btn02"
            >资质荣誉</router-link
          >
          <router-link to="/about/album" title="企业风采" class="ab_btn03"
            >企业风采</router-link
          >
        </div>
      </div>
    </div>
    <div class="album content">
      <h2 class="four_t">
        <router-link to="/about/album" target="_blank" title="关于我们">
          <em><img src="@img/xw_icon01.jpg"/></em>
          企业相册
        </router-link>
      </h2>
      <!-- 企业相册展示 -->
      <div class="albumSlide">
        <div class="swiper-button-prev swiper-button-black"></div>
        <swiper :options="albumSwiperOption" v-if="albumList.length > 0">
          <swiper-slide v-for="(item, index) in albumList" :key="index">
            <router-link to="/about/album">
              <img
                class="img"
                :src="item.article_img"
                :alt="item.title"
                :title="item.title"
              />
            </router-link>
            <p>{{ item.title }}</p></swiper-slide
          >
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="swiper-button-next swiper-button-black"></div>
      </div>
      <!-- 企业相册展示 -->
    </div>

    <!-- 友情链接 -->
    <div class="links_bg">
      <div class="links content">
        <p class="links_l fl">友情链接</p>
        <p class="links_c fl">
          <a
            :href="item.url"
            target="_blank"
            v-for="(item, index) in friendShip"
            :key="index"
            >{{ item.name }}</a
          >
          <br />
        </p>
      </div>
      <p></p>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import scroll from "vue-seamless-scroll";
import countTo from "vue-count-to";
import utils from "@/api/to_py.js";
export default {
  data() {
    return {
      swiperOption: {
        loop: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination"
        },
        observeParents: true,
        observer: true
      },
      anliSwiperOption: {
        loop: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination"
        },
        observeParents: true,
        observer: true
      },
      problemList: [],
      tempWrapOption: {
        direction: "vertical",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        loop: true,
        slidesPerView: "auto",
        autoplay: {
          delay: 800,
          stopOnLastSlide: false,
          disableOnInteraction: true
        }
      },
      swiperSlides: [],
      products: [],
      startVal: 0,
      endVal1: new Date().getFullYear() - 1996,
      endVal2: 312,
      endVal3: 7,
      endVal4: 130,
      autoplay: true,
      friendShip: [],
      imgBaseUrl: this.$imgBaseUrl,
      newList: [],
      firstNew: {},
      newsTypes: [
        { name: "公司新闻", id: 15, path: "/news/gsxw", pyname: "gsxw" },
        { name: "行业动态", id: 14, path: "/news/xydt", pyname: "xydt" },
        {
          name: "设备操作视频",
          id: 26,
          path: "/news/sbczsp",
          pyname: "sbczsp"
        }
      ],
      activeAnli: 22,
      anliList: [],
      newAnli: [],
      indexCaseList: [
        {
          typeCh: "新型包子机",
          typeEn: "New type of baozi machine",
          mainT: "多功能包子机",
          subT: "双料斗设计",
          advantage: [
            {
              title: "智能数控面板",
              info: "包子大小可调节 馅料多少可调节 可换馅料"
            },
            {
              title: "创新工艺",
              info: "改进型缓压式输面系统<br/>包子大小 皮薄后馅多少精确可调"
            }
          ],
          imgUrl: ""
        },
        {
          typeCh: "和面机",
          typeEn: "Doughmaker",
          mainT: "多功能包子机",
          subT: "双料斗设计",
          advantage: [
            {
              title: "智能数控面板",
              info: "包子大小可调节 馅料多少可调节 可换馅料"
            },
            {
              title: "创新工艺",
              info: "改进型缓压式输面系统<br/>包子大小 皮薄后馅多少精确可调"
            }
          ],
          imgUrl: ""
        },
        {
          typeCh: "圆馒头生产线",
          typeEn: "Round bread production line",
          mainT: "多功能包子机",
          subT: "双料斗设计",
          advantage: [
            {
              title: "智能数控面板",
              info: "包子大小可调节 馅料多少可调节 可换馅料"
            },
            {
              title: "创新工艺",
              info: "改进型缓压式输面系统<br/>包子大小 皮薄后馅多少精确可调"
            }
          ],
          imgUrl: ""
        },
        {
          typeCh: "500型自动揉面机",
          typeEn: "Model 500 automatic kneading machine",
          mainT: "多功能包子机",
          subT: "双料斗设计",
          advantage: [
            {
              title: "智能数控面板",
              info: "包子大小可调节 馅料多少可调节 可换馅料"
            },
            {
              title: "创新工艺",
              info: "改进型缓压式输面系统<br/>包子大小 皮薄后馅多少精确可调"
            }
          ],
          imgUrl: ""
        },
        {
          typeCh: "双开门黄金屋面点蒸柜",
          typeEn: "Double door golden roof spot steam cabinet",
          mainT: "多功能包子机",
          subT: "双料斗设计",
          advantage: [
            {
              title: "智能数控面板",
              info: "包子大小可调节 馅料多少可调节 可换馅料"
            },
            {
              title: "创新工艺",
              info: "改进型缓压式输面系统<br/>包子大小 皮薄后馅多少精确可调"
            }
          ],
          imgUrl: ""
        },
        {
          typeCh: "DMT90-Ⅲ（触摸屏控制）馒头机",
          typeEn: "Dmt90 - Ⅲ (touch screen control) steamed bread machine",
          mainT: "多功能包子机",
          subT: "双料斗设计",
          advantage: [
            {
              title: "智能数控面板",
              info: "包子大小可调节 馅料多少可调节 可换馅料"
            },
            {
              title: "创新工艺",
              info: "改进型缓压式输面系统<br/>包子大小 皮薄后馅多少精确可调"
            }
          ],
          imgUrl: ""
        }
      ],
      curIndex: 0,
      albumList: [],
      albumSwiperOption: {
        loop: true,
        slidesPerView: 5,
        slidesPerGroup: 5,
        spaceBetween: 30,
        // loopedSlides: 21,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  mounted() {
    this.getbanner();
    this.getFriendShip();
    this.getRroductType();
    this.findAllNews();
    this.getProblem_list();
    this.getNewAnliList(22);
    this.getAlbumList();
  },
  methods: {
    getAlbumList() {
      this.$post("/Article/article_list", {
        classifyid: 19,
        limit: 20
      }).then(response => {
        this.albumList = response.data;
      });
    },
    initSwiper() {
      //
      // var sw = new swiper('.fullSlide', {
      //   loop: true,
      //   observer: true, //修改swiper自己或子元素时，自动初始化swiper
      //   observeParents: true, //修改swiper的父元素时，自动初始化swiper
      //   autoplay: {
      //     delay: 3000,
      //     disableOnInteraction: false
      //   },
      //   pagination: {
      //     el: '.swiper-pagination'
      //   },
      //   observeParents: true,
      //   observer: true
      // });
    },
    getNewAnliList: function(type) {
      this.activeAnli = type;
      this.$post("/Article/article_list", {
        // classifyid: "22,23,24,25",
        classifyid: type,
        limit: 6
      }).then(response => {
        this.anliList = response.data || [];
        // this.newAnli = [response.data[0], response.data[1]];
      });
    },
    getProblem_list: function() {
      this.$post("/Problem/problem_all", {}).then(response => {
        this.problemList = response.data || [];
      });
    },
    findAllNews: function() {
      this.$post("/Article/article_list", {
        classifyid: "15",
        limit: 8,
        is_recommend: 1
      }).then(response => {
        this.newList = response.data || [];
        this.firstNew = response.data[0];
      });
    },
    getRroductType: function() {
      this.$post("/Product/product_class_list", {}).then(response => {
        this.products = response.data || [];
      });
    },
    getbanner: function() {
      this.$post("/api/getbanner", {}).then(response => {
        // console.log(response);
        this.swiperSlides = JSON.parse(response.data.banner);
      });
    },
    getFriendShip: function() {
      this.$post("/api/getfriendship", {}).then(response => {
        // console.log(response);
        this.friendShip = response.data || [];
      });
    }
  },
  components: {
    swiper,
    swiperSlide,
    countTo,
    scroll
  },
  filters: {
    toNewDetail(id, arrs, idd) {
      var baseurl = "/newsdetail/";
      arrs.forEach(element => {
        if (element.id == id) {
          baseurl += utils.ConvertPinyin(element.name) + "/0" + idd + ".html";
          return;
        }
      });
      return baseurl;
    },
    toProDetail(parm, url) {
      var str = utils.ConvertPinyin(parm);
      if (url) str = url + str;
      return str;
    }
  },
  computed: {
    classOption() {
      return {
        waitTime: 2000,
        step: 0.5
      };
    }
  }
};
</script>

<style lang="less">
@import "~@css/index.less";
</style>



// WEBPACK FOOTER //
// src/components/index.vue